module.exports = __webpack_public_path__ + "img/wumpus_a.a52c8e76.png";